import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { CategoryLandingProps } from '../../../../containers/MergedStore/Category/CategoryLanding.types'
import { FC } from 'react'
import { PrimaryButton } from '@dtx-company/shared-components/src/components/atoms/Button/index'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'
import events from '@dtx-company/inter-app/src/event-tracking/events/printStore'

export const MergedStoreCategoryBottomBanner: FC<
  Pick<
    CategoryLandingProps,
    | 'bottombannertitle'
    | 'bottombannerdescription'
    | 'bottombannerimage'
    | 'bottombannerimagetablet'
    | 'bottombannerimagemobile'
  >
> = ({
  bottombannertitle,
  bottombannerdescription,
  bottombannerimage,
  bottombannerimagemobile,
  bottombannerimagetablet
}) => {
  return (
    <Box
      backgroundColor={'#E0E2E3'}
      justifyContent="center"
      alignItems={{ _: 'baseline', md: 'center' }}
      padding={{ _: '32px 0 0', md: '0 0 0 20px' }}
      backgroundImage={{
        _: `url(${bottombannerimagemobile?.url})`,
        md: `url(${bottombannerimagetablet?.url})`,
        lg: `url(${bottombannerimage?.url})`
      }}
      backgroundPosition="center"
      backgroundSize={'cover'}
      height={{ _: '439px', md: '247px', lg: '339px' }}
      data-testid="bottom-banner"
    >
      <Box flexDirection={'column'} padding={{ _: '0 13px', md: 0 }} alignItems={'center'}>
        <PrismicText
          richTextField={bottombannertitle}
          variant={['display/small', 'display/small', 'display/medium']}
          fontSize={{ _: '24px', lg: '28px' }}
          textAlign={'center'}
          maxWidth={{ _: '316px', md: '498px' }}
          fontWeight={600}
        />
        <Spacer mb="15px" />
        <PrismicText
          richTextField={bottombannerdescription}
          variant={['body/medium', 'body/medium', 'body/large']}
          textAlign={'center'}
          maxWidth={{ _: '278px', md: '368px' }}
        />
        <Spacer mb={{ _: '12px', md: '28px', lg: '42px' }} />
        <PrimaryButton
          label="Get my Flowtag now ->"
          data-testid="get-flowtag"
          onClick={() => {
            events.Flowcode_Store_Clicked_Bottom_Banner_Get_Flowtag_Btn()
          }}
        />
      </Box>
    </Box>
  )
}
